import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import callApi from '../../helpers/callapi'

export default ({ bookTable, perRow, setBarcode, setLotteries, setLoading, roundDate, isHilight }) => {
  return (
    <BookHolder>
      <TR>
        <Cell>แถวที่</Cell>
        <Cell>งวดที่</Cell>
        <Cell>ชุดที่</Cell>
        <Cell>เล่มที่</Cell>
        <Cell>จำนวนคู่</Cell>
      </TR>
      {bookTable.map((book, i) => {
        return (
          <Book
            key={i}
            width={100 / perRow}
            hilight={isHilight(book)}
            onClick={() => setBarcode(Object.values(book.seriesNo) && Object.values(book.seriesNo)[0])}
          >
            <Cell>{Math.ceil((i + 1) / perRow)}</Cell>
            <Cell id={book.id}>{book.roundNo}</Cell>
            <Cell id={book.id}>{Object.keys(book.seriesNo).join(',')}</Cell>
            <Cell id={book.id}>{book.volume}</Cell>
            <Cell>{book.seriesNo.length || 0}</Cell>
          </Book>
        )
      })}
    </BookHolder>
  )
}
const BookHolder = styled.div`
  display: table;
  width: 100%;
`
const TR = styled.tr`
  background-color: #f9f9f9;
`

const Book = styled.div`
  display: table-row;
  background-color: ${(props) => props.hilight && 'yellow'};
  flex: ${(props) => props.width}%;
  border: 1px solid black;
`
const Cell = styled.div`
  display: table-cell;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
`
